import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ProductPageData } from '@core/constants/product-instant-data';
import { RaffleInstantType } from '@core/models/raffle-instant-type.enum';

@Component({
  selector: 'app-product-how-works',
  templateUrl: './product-how-works.component.html',
  styleUrls: ['./product-how-works.component.scss']
})
export class ProductHowWorksComponent implements OnChanges {
  @Input() instantType: RaffleInstantType;

  steps: { label: string; icon: string }[];

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.instantType) {
      this.steps = [
        {
          label: ProductPageData[this.instantType].howWorksFirstStepLabel,
          icon: ProductPageData[this.instantType].howWorksFirstStepIcon
        },
        {
          label: ProductPageData[this.instantType].howWorksSecondStepLabel,
          icon: 'hw-reveal.svg'
        },
        {
          label: ProductPageData[this.instantType].howWorksThirdStepLabel,
          icon: 'hw-prize.svg'
        }
      ];
    }
  }
}
